module.exports = __webpack_public_path__ + "img/8.b851e7a7.jpg";